import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";
import UAParser from "ua-parser-js";

import CollectionPageLayout from "components/CollectionPageLayout";
import { collectionLayoutData } from "components/CollectionPageLayout/collectionLayoutData";
import CollectionPageAnalysis from "components/CollectionPageLayout/CollectionPageAnalysis";
import {
  collectionInsightsUrl,
  sortOptions,
} from "components/CollectionPageLayout/CollectionPageAnalysis/CollectionPageInsightsList";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const EntityInsightsTabPage: NextPageWithLayout = () => {
  return <CollectionPageAnalysis />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const slug = context.params?.slug as string;

  const userAgent = context.req.headers["user-agent"] as string;
  const deviceType = new UAParser(userAgent).getDevice().type;
  const isMobile = deviceType === "mobile";
  const session = JSON.parse(
    decodeURIComponent(context.req.cookies["ember_simple_auth-session"] || "{}")
  );
  const authenticated = !!session.authenticated?.token;

  const publicationsUrl = collectionInsightsUrl(
    slug,
    1,
    {},
    sortOptions[0].sortStr,
    isMobile,
    authenticated
  );

  try {
    const [{ collection, collectionLayoutFallback }, publications] =
      await Promise.all([
        collectionLayoutData(slug, context),
        isSsr(context)
          ? baseFetcher(publicationsUrl, context)
          : Promise.resolve(null),
      ]);

    if (!collection || collection.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        fallback: {
          ...collectionLayoutFallback,
          [`$inf$${publicationsUrl}`]: [publications],
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps collection Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

EntityInsightsTabPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <CollectionPageLayout {...pageProps}>{page}</CollectionPageLayout>
    </SWRConfig>
  );
};

export default EntityInsightsTabPage;
